import React from "react";
import { useAppSelector as useSelector } from "../../../../store";

const NextOfKin: React.FC = () => {
  const emergencyInfo = useSelector(
    (state) => state.onboarding.emergencyinfodetails
  );

  return (
    <div className="d-flex flex-column gap-10">
      <div className="fs-16 fw-400 text-black">
        Please provide details for your next of kin who should be contacted in
        the event of an emergency.
      </div>
      <div className="d-flex gap-50 flex-wrap">
        <div className="d-flex flex-column gap-5">
          <div className="fs-13 fw-400 text-grey-medium">First Name</div>
          <div className="fs-16 fw-400 text-black">
            {emergencyInfo?.first_name ?? "-"}
          </div>
        </div>
        <div className="d-flex flex-column gap-5">
          <div className="fs-13 fw-400 text-grey-medium">Last Name</div>
          <div className="fs-16 fw-400 text-black">
            {emergencyInfo?.last_name ?? "-"}
          </div>
        </div>
      </div>
      <div className="d-flex flex-column gap-5">
        <div className="fs-13 fw-400 text-grey-medium">Phone Number</div>
        <div className="fs-16 fw-400 text-black">
          {emergencyInfo?.phone_number ?? "-"}
        </div>
      </div>
      <div className="d-flex flex-column gap-5">
        <div className="fs-13 fw-400 text-grey-medium">Relationship</div>
        <div className="fs-16 fw-400 text-black">
          {emergencyInfo?.relationship ?? "-"}
        </div>
      </div>
    </div>
  );
};

export default NextOfKin;
